var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.css.wrapper,attrs:{"aria-label":_vm.address}},[_c('Identicon',{class:_vm.css.icon,attrs:{"text":_vm.address,"size":_vm.iconSize}}),_vm._v(" "),_c('router-link',{class:_vm.css.address,attrs:{"to":_vm.toLink}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }